/**
 * Pojedyncze źródło prawdy dla wszystkich tekstów autocomplete adresu/miasta.
 * Każda zmiana tonu czy literówki - tylko tutaj.
 */
export type AutocompleteType = "city" | "address";

export const AUTOCOMPLETE_COPY: Record<
  AutocompleteType,
  {
    placeholder: string;
    hint: string;
    loading: string;
    empty: string;
  }
> = {
  city: {
    placeholder: "Wpisz miasto, np. Warszawa",
    hint: "",
    loading: "Szukam miast…",
    empty:
      "Brak miast pasujących do wpisanej nazwy. Sprawdź pisownię lub wpisz pełniejszą nazwę.",
  },
  address: {
    placeholder: "Wpisz ulicę, np. Marszałkowska 15",
    hint: "",
    loading: "Szukam adresów…",
    empty:
      "Brak adresów pasujących do wpisanej nazwy. Sprawdź pisownię ulicy lub dodaj numer domu.",
  },
};

export const AUTOCOMPLETE_COMMON_COPY = {
  /** Komunikat błędu sieciowego/serwerowego dla obu typów. */
  fetchError:
    "Nie udało się pobrać podpowiedzi. Sprawdź połączenie i spróbuj ponownie.",
  /** Generic loading - używany przed wyborem typu. */
  loadingGeneric: "Szukam podpowiedzi…",
} as const;
